export default "__VITE_ASSET__CDz7cF5$__"